import request from '@/utils/request'

// 获取指定学校的校区和楼栋数据：
const getClassroomFilterTree = (params) => {
  return request({
    url: '/admin/classroom/filterTree',
    method: 'get',
    params
  })
}

// 教室列表
const getClassroomList = (params) => {
  return request({
    url: '/admin/classroom/searchByPage',
    method: 'post',
    data: params
  })
}

// 新增教室及设备
const createClassroom = (params) => {
  return request({
    url: '/admin/classroom/create',
    method: 'post',
    data: params
  })
}

// 修改教室及设备
const updateClassroom = (params) => {
  return request({
    url: '/admin/classroom/update',
    method: 'post',
    data: params
  })
}
// 查询所有教室二维码
const queryAllClassroomQr = (params) => {
  return request({
    url: '/admin/classroom/queryAllClassroomQr',
    method: 'post',
    data: params
  })
}

// 教室详情
const getClassroomDetail = (params) => {
  return request({
    url: '/admin/classroom/detail',
    method: 'get',
    params
  })
}

// 设备列表
const getDeviceList = (params) => {
  return request({
    url: '/admin/device/searchByPage',
    method: 'get',
    params
  })
}

// 添加设备
const addDevice = (params) => {
  return request({
    url: '/admin/device/add',
    method: 'post',
    data: params
  })
}
// 编辑设备
const updateDevice = (params) => {
  return request({
    url: '/admin/device/update',
    method: 'post',
    data: params
  })
}
// 删除设备
const deleteDevice = (params) => {
  return request({
    url: '/admin/device/delete',
    method: 'post',
    params
  })
}
// 获取设备详情
const getDeviceDetail = (params) => {
  return request({
    url: '/admin/device/detail',
    method: 'get',
    params
  })
}
// 获取所有机位类型
const getAllDeviceTypes = (params) => {
  return request({
    url: '/admin/device/allDeviceTypes',
    method: 'get',
    params
  })
}

// 查询教室高级设置
const advancedSettingQuery = (params) => {
  return request({
    url: 'admin/classroom/advancedSetting',
    method: 'get',
    params
  })
}

// 编辑教室高级设置
const advancedSettingEdit = (params) => {
  return request({
    url: 'admin/classroom/advancedSetting/edit',
    method: 'post',
    data: params
  })
}

// 当前教室是否有正在进行中的课
const checkRunningLive = (params) => {
  return request({
    url: 'admin/classroom/checkRunningLive',
    method: 'post',
    params
  })
}

// 根据屏幕数量获取前后墙默认配置
const defaultScreenConfig = (params) => {
  return request({
    url: 'admin/classroom/defaultScreenConfig',
    method: 'post',
    data: params
  })
}

// 导出教室列表
const exportClassroomList = (params) => {
  return request({
    url: 'admin/classroom/exportClassroom',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 获取客户端配置
const getClassroomClientSet = (params) => {
  return request({
    url: 'admin/client/setting/getByClassroomCode',
    method: 'get',
    params
  })
}

// 解绑客户端
const unbindClassroomByAddr = (params) => {
  return request({
    url: 'admin/client/setting/unbindClassroomByAddr',
    method: 'get',
    params
  })
}
// 编辑客户端配置
const editClientSetup = (params) => {
  return request({
    url: 'admin/client/setting/editSetting',
    method: 'post',
    data: params
  })
}

export default {
  getClassroomFilterTree,
  getClassroomList,
  createClassroom,
  getClassroomDetail,
  getDeviceList,
  updateClassroom,
  addDevice,
  deleteDevice,
  updateDevice,
  getDeviceDetail,
  queryAllClassroomQr,
  advancedSettingQuery,
  advancedSettingEdit,
  getAllDeviceTypes,
  checkRunningLive,
  defaultScreenConfig,
  exportClassroomList,
  getClassroomClientSet,
  unbindClassroomByAddr,
  editClientSetup
}
